// import { scan } from 'react-scan';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppWrapper, BrowserRouter } from './app';

// scan({
//   enabled: window.location.hostname === 'localhost',
// });

const container = document.getElementById('root');

function App() {
  // Appwrapper needs to be outside to initialize sentry before creating "sentryCreateBrowserRouter" inside "BrowserRouter.tsx"
  return (
    <AppWrapper themePrimaryColor={'vrplatform'}>
      <BrowserRouter />
    </AppWrapper>
  );
}

function startApp() {
  if (container) {
    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <div className="App">
          <App />
        </div>
      </React.StrictMode>
    );
  }
}

startApp();
